import { ProjectChannel } from 'api/pushes';
import { ManagerPropsWithLoadedRange } from '../../types';
import { useProjectMembersCreateWSManager } from './project-members-create';
import { useProjectMembersDeleteWSManager } from './project-members-delete';
import { useProjectMembersUpdateWSManager } from './project-members-update';

export interface ProjectMembersWsProps extends ManagerPropsWithLoadedRange {
  projectChannels: ProjectChannel[];
}
export const useProjectMembersWSManager = (
  props: ProjectMembersWsProps,
): void => {
  useProjectMembersUpdateWSManager(props);
  useProjectMembersCreateWSManager(props);
  useProjectMembersDeleteWSManager(props);
};
